import React from "react";
import Select from "react-select";

const CustomClearText = () => "borrar todo";

const ClearIndicator = (props) => {
  const {
    children = <CustomClearText />,
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;

  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={getStyles("clearIndicator", props)}
    >
      <div style={{ padding: "0px 5px" }}>{children}</div>
    </div>
  );
};

const ClearIndicatorStyles = (base, state) => ({
  ...base,
  cursor: "pointer",
  color: state.isFocused ? "blue" : "black",
});

const normalizeOption = (option) => {
  if (option == null) {
    return { value: "", label: "" };
  }

  if (typeof option === "string" || typeof option === "number") {
    const primitive = String(option);
    return { value: option, label: primitive };
  }

  const value =
    option.slug ??
    option.uuid ??
    option.value ??
    option.id ??
    option.codigo ??
    "";

  const label =
    option.nombre ??
    option.label ??
    option.name ??
    option.descripcion ??
    (value !== "" ? String(value) : "");

  return {
    value,
    label,
  };
};

export default function CustomClearIndicator({
  options,
  onChange,
  defaultsValues,
  isMulti = true,
  placeholder = "Seleccione ..",
  ...selectProps
}) {
  const validOptions = Array.isArray(options) ? options : [];

  const mappedDefaultsValues = Array.isArray(defaultsValues)
    ? defaultsValues.map((defaultValue) => normalizeOption(defaultValue))
    : [];

  const mappedOptions = validOptions.map((option) => normalizeOption(option));

  const defaultValue = isMulti ? mappedDefaultsValues : mappedDefaultsValues[0];

  return (
    <Select
      closeMenuOnSelect={!isMulti}
      components={{ ClearIndicator }}
      styles={{ clearIndicator: ClearIndicatorStyles }}
      defaultValue={defaultValue}
      onChange={onChange}
      isMulti={isMulti}
      options={mappedOptions}
      placeholder={placeholder}
      {...selectProps}
    />
  );
}
